<template>
  <Fragment>
    <VBtn
      v-if="$vuetify.breakpoint.mdAndDown"
      icon
      @click="show"
    >
      <VIcon>domain</VIcon>
    </VBtn>
    <VBtn
      v-else
      text
      color="secondary"
      :title="account?.parent_title"
      @click="show"
    >
      <VIcon
        left
        size="24"
      >
        domain
      </VIcon>
      {{ currentParentShortName }}
    </VBtn>

    <VDialog
      v-model="dialog"
      max-width="700"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <VCard>
        <VCardTitle class="headline">
          Выберите организацию, которая направила вас на&nbsp;обучение:

          <VSpacer />
          <VBtn
            :title="$t('close.one')"
            icon
            @click="close"
          >
            <VIcon>close</VIcon>
          </VBtn>
        </VCardTitle>
        <VDivider />
        <VCardText class="pt-4">
          <VList class="org-list">
            <VListItem
              v-for="item in accounts"
              :key="item.id"
              @click="changeUserAccount(item)"
            >
              <VListItemIcon>
                <VIcon
                  v-if="item.uuid === account.uuid"
                  color="primary"
                >
                  check_circle
                </VIcon>

                <VIcon
                  v-else
                >
                  radio_button_unchecked
                </VIcon>
              </VListItemIcon>
              <VListItemContent>
                <VListItemTitle class="text-wrap">
                  {{ getPreparedTitle(item) }}
                </VListItemTitle>
              </VListItemContent>
            </VListItem>
          </VList>
        </VCardText>
      </VCard>
    </VDialog>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import { changeAccount, getAccounts } from '@/api/api'

export default {
  name: 'OrganizationSwitchMenu',

  components: {
    Fragment,
  },

  props: {
    account: {
      type: Object,
      default: () => {},
    },
  },

  data () {
    return {
      dialog: false,
      loading: false,
      accounts: undefined,
    }
  },

  computed: {
    currentParentShortName () {
      return this.getShortName(this.account?.parent_title)
    },
  },

  methods: {
    getShortName (name) {
      if (!name) return ''

      return name.length > 12
        ? `${name.slice(0, 12)}…`
        : name
    },
    async changeUserAccount (item) {
      if (this.loading || item.uuid === this.account.uuid) return

      try {
        this.loading = true
        await changeAccount(item.id)
        window.location.reload()
      } catch {
        //
      } finally {
        this.loading = false
      }
    },
    async getAccounts () {
      try {
        this.loading = true
        const { users } = await getAccounts()
        this.accounts = users
        return this.accounts
      } catch {
        //
      } finally {
        this.loading = false
      }
    },

    getPreparedTitle (account) {
      const title = account.parent_title

      if (account.position) {
        return title + ', ' + account.position
      }

      return title
    },

    async show () {
      if (this.accounts === undefined) {
        await this.getAccounts()
      }
      this.dialog = true
    },

    close () {
      this.dialog = false
    },
  }
}
</script>
